import { AccountUserInformationSSOEntry } from "./AccountUserInformationSSOEntry";

export class AccountUserInformationSSO {
    enabledForAccount: boolean = false;
    authenticated: boolean = false;
    ssoEntries: AccountUserInformationSSOEntry[] = [];
}